import { IPaginationQuery } from '../../rest/IPaginationQuery';
import { ISortQuery } from '../../rest/ISortQuery';
import { eMatchedQueryValue } from '../eMatchedQueryValue';
import { TDateTimeRangeQueryValue } from '../../shared/TDateTimeRangeQueryValue';
import { convertISODateRangeToISODateTimeRange } from '../../../utilities/accounting/convertISODateRangeToISODateTimeRange/convertISODateRangeToISODateTimeRange';
import { IEscrowExpectedIncomingAchTableQuery } from './IEscrowExpectedIncomingAchTableQuery';
import { IEscrowMatchAchPullDepositsResponse } from '../response/IEscrowExpectedAchPullDepositResponse';
import { ISODateTimeString } from 'types/shared/ISODateTimeString';

/** Pseudo API contract */
export interface IEscrowExpectedIncomingAchQuery extends IPaginationQuery, ISortQuery {
  amountCents?: number;
  amountCentsMax?: number;
  wellsFargoTransactionNumber?: string;
  borrowerName?: string;
  createdAt?: TDateTimeRangeQueryValue;
  bankAccountName?: string;
  fileNumber?: string;
  escrowFileId?: string;
  matched?: eMatchedQueryValue;
  propertyAddress?: string;
  matches?: IEscrowMatchAchPullDepositsResponse;
  enqueuedForDisbursementAt?: ISODateTimeString;
  enqueuedForDisbursementAtStart?: ISODateTimeString;
  enqueuedForDisbursementAtEnd?: ISODateTimeString;
  fetchAll?: boolean;
}

export const convertExpectedIncomingAchTableQueryToApiQuery = (
  q: IEscrowExpectedIncomingAchTableQuery
): IEscrowExpectedIncomingAchQuery => {
  return {
    ...q,
    createdAt: q.createdAt && convertISODateRangeToISODateTimeRange(q.createdAt),
  };
};
